import { TrackEventVerb as UiTrackEventVerb } from '@updater/ui-tracker';

export type TrackEventVerb = UiTrackEventVerb | 'reset';
export interface AnalyticsObject extends Record<string, unknown> {}

export enum Events {
  PAGE_LOAD = 'page_load',
  QUAL = 'qual',
  LANDING = 'landing',
  PLANS = 'offers_page',
  OFFERS_LOADING = 'offers_loading',
  VIEW_DETAILS = 'view_details',
  PROVIDERS = 'providers',
  SERVICE_SELECTION = 'service_selection',
  FILTER = 'filter',
  CHANGE_ADDRESS = 'change_address',
  INTERNET_SPEED = 'internet_speed',
  OFFERS_SORT = 'offers_sort',
  SEARCH_OFFERS_WAIT_TIME = 'search_offers_wait_time',
  SESSION_TIMEOUT = 'session_timeout',
  SESSION_TIMEOUT_PHONE = 'session_timeout_phone',
  VERIFY_ADDRESS_UNIT_NEEDED = 'verify_address_unit',
  VERIFY_ADDRESS = 'verify_address',
  VERIFY_ADDRESS_PHONE = 'verify_address_phone',
  ADDRESS_SUGGESTIONS = 'address_suggestions',
  ADDRESS_SUGGESTIONS_VERIFY_ADDRESS = 'address_suggestions_verify_address',
  FULL_ADDRESS = 'full_address',
  SKIP_QUESTIONS = 'skip_questions',
  CALL_BUTTON_GENERIC = 'call_button',
  CALL_BUTTON_MOBILE_HEADER = 'mobile_call_button',
  CALL_BUTTON_DESKTOP_HEADER = 'desktop_call_button',
  CALL_BUTTON_MOBILE_RESULTS = 'results_mobile_call_button',
  CALL_BUTTON_DESKTOP_RESULTS = 'results_desktop_call_button',
  CALL_BUTTON_ERROR_PAGE = 'error_phone',
  PRIVACY_AND_TERMS_CONSENT = 'privacy_and_terms_consent',
  APPFOLIO_LANDING = 'appfolio_landing', // @deprecated, use LANDING
  CHOICE_GATE = 'choice_gate',
  CHOICE_GATE_CHAT_SELECTED = 'choice_gate_chat_selected',
  CHOICE_GATE_BROWSE_SELECTED = 'choice_gate_browse_selected',
  AGENT_CHAT_VIEWED = 'agent_chat_viewed',
  AGENT_PLAN_SELECTED = 'agent_plan_selected',
  AGENT_RESERVATION_COMPLETE = 'agent_reservation_complete',
  ORGANIC_CHAT_ERROR_VIEWED = 'organic_chat_error_viewed',
  ORGANIC_CHAT_ERROR_REDIRECT = 'organic_chat_error_redirect',
  SEE_ALL_PLANS_CLICKED = 'see_all_plans_clicked',
  COMMERCIAL_ADDRESS = 'commercial_address',
}
